export default "__VITE_ASSET__DRv$gdz9__"